import { GatsbyImage } from 'gatsby-plugin-image';

import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';

import { ISanityContentCard } from 'typescriptDefs';

import { useIsMobileSize } from 'helpers';

type Props = ISanityContentCard;

const AboutContent = ({ description, heading, image }: Props) => {
  const isMobile = useIsMobileSize();
  return (
    <>
      <div className="mb-32 text-center md:mb-64 [&_h2]:mb-8 [&_h2]:text-secondary-75 md:[&_h2]:mb-20 [&_h2_strong]:text-secondary-50">
        <CustomPortableText content={heading} />
      </div>
      <div className="grid grid-cols-1 gap-32 md:grid-cols-2 md:gap-64">
        <div className="my-auto [&_svg]:text-secondary-75">
          <CustomPortableText content={description} />
        </div>
        {isMobile ? (
          <GatsbyImage
            className="max-h-312 rounded-16 xs:max-h-400"
            image={image.img.asset.gatsbyImageData}
            alt={image.altText}
          />
        ) : (
          <GatsbyImage className="min-h-480 rounded-16" image={image.img.asset.gatsbyImageData} alt={image.altText} />
        )}
      </div>
    </>
  );
};

const About = (props: Props) => {
  const isMobile = useIsMobileSize();
  return (
    <Section className="bg-primary-500 px-32 py-64 text-white md:bg-transparent md:px-0 md:py-0">
      {isMobile ? (
        <AboutContent {...props} />
      ) : (
        <Container className="rounded-24 bg-primary-500 px-64 py-64">
          <AboutContent {...props} />
        </Container>
      )}
    </Section>
  );
};

export default About;
